import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../store/slices/authSlice';
import Swal from 'sweetalert2';
import logo from '../../assets/images/logo.png';
import FooterSection from '@/components/Footer/LoginFooter';
import styles from './SecurityVerification.module.css';

const SecurityCodeVerification = () => {
    const [code, setCode] = useState(['', '', '', '', '', '']);
    const inputs = useRef([]);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { staffId, isOwner } = location.state || {};

    useEffect(() => {
        if (!staffId) {
            navigate('/login');
        }
        // Focus first input
        if (inputs.current[0]) {
            inputs.current[0].focus();
        }
    }, [staffId, navigate]);

    const handleChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;

        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        // Auto-focus next input
        if (value && index < 5) {
            inputs.current[index + 1].focus();
        }

        // Auto-submit if all filled
        if (newCode.every(digit => digit !== '') && index === 5 && value) {
            handleVerify(newCode.join(''));
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handleVerify = async (otpValue) => {
        try {
            const response = await authService.verify2FA(staffId, otpValue, isOwner);
            
            if (response.token) {
                // Handle both owner and staff responses
                const userData = response.owner || response.staff;
                const role = isOwner ? 'owner' : (userData?.role || 'staff');
                
                dispatch(setCredentials({
                    token: response.token,
                    user: userData,
                    role: role
                }));
                
                // Set active role in localStorage
                localStorage.setItem('activeRole', role);
                if (isOwner && response.owner) {
                    localStorage.setItem('ownerToken', response.token);
                } else if (response.staff) {
                    localStorage.setItem('staffToken', response.token);
                }
                
                Swal.fire({
                    icon: 'success',
                    title: 'Verification Successful',
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    navigate('/dashboardhome');
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Verification Failed',
                text: error.response?.data?.error || error.message || 'Invalid code'
            });
            // Clear code on error
            setCode(['', '', '', '', '', '']);
            inputs.current[0].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6).split('');
        if (pastedData.every(char => /^\d$/.test(char))) {
             const newCode = [...code];
             pastedData.forEach((char, index) => {
                 if (index < 6) newCode[index] = char;
             });
             setCode(newCode);
             
             // Focus valid next input
             const nextIndex = Math.min(pastedData.length, 5);
             inputs.current[nextIndex].focus();

             if (newCode.every(d => d !== '')) {
                 handleVerify(newCode.join(''));
             }
        }
    };

    return (
        <div className={`min-h-screen bg-[#333d79] px-4 ${styles.container}`}>
             <div className="absolute inset-0 overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_50%)]"></div>
            </div>

            <div className="relative w-full max-w-2xl mx-auto text-center z-10">
                 <div className="mb-8">
                     <img src={logo} alt="Lords Exch" className="h-[100px] object-contain mx-auto mb-2" />
                 </div>

                 <div style={{marginTop: '40px'}} className="text-[28px] text-center text-white font-bold mb-1">Security Code Verification Using Telegram App</div>
                 <div className="text-white text-[14px] mb-2 mt-2 font-bold">Enter 6-digit code from your telegram bot Resend Code</div>
                 {/* <div className="text-gray-300 text-sm mb-8">Enter 6-digit code from your telegram bot Resend Code</div> */}

                 <div className="flex justify-center mb-8">
                    <div className={styles.otpContainer} data-is-input-num="true">
                        {code.map((digit, index) => (
                            <div key={index} className={styles.otpInputWrapper}>
                                <input
                                    ref={el => inputs.current[index] = el}
                                    type="tel"
                                    min="0"
                                    max="9"
                                    maxLength={1}
                                    pattern="[0-9]"
                                    value={digit}
                                    onChange={(e) => handleChange(index, e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    onPaste={index === 0 ? handlePaste : undefined}
                                    className={styles.otpInput}
                                />
                            </div>
                        ))}
                    </div>
                 </div>
                 
 

            </div>
            
            {/* <FooterSection /> */}
        </div>
    );
};

export default SecurityCodeVerification;
